export default {
  placeholder: 'Filtruj według przepisu',
};
